const modifyArray = (arr) => {
  return arr.map((item) => [item, item]);
};

export const static_layout_directed = modifyArray(['circular', 'force']);
export const static_row_limit = modifyArray([
  3, 5, 10, 20, 50, 100, 200, 250, 500, 1000, 2500, 5000, 10000, 25000, 50000,
]);

export const static_bottom_margin = modifyArray(['auto', 50, 75, 100, 125, 150, 200]);

export const static_table_timestamp_format = [
  ['smart_date', 'Adaptative formating'],
  ['%d/%m/%Y', '%d/%m/%Y | 14/01/2019'],
  ['%m/%d/%Y', '%m/%d/%Y | 01/14/2019'],
  ['%Y-%m-%d', '%Y-%m-%d | 2019-01-14'],
  ['%Y-%m-%d %H:%M:%S', '%Y-%m-%d %H:%M:%S | 2019-01-14 01:32:10'],
  ['%d-%m-%Y %H:%M:%S', '%d-%m-%Y %H:%M:%S | 14-01-2019 01:32:10'],
  ['%H:%M:%S', '%H:%M:%S | 01:32:10'],
];

export const static_style_tooltips = [
  ['item', 'Single'],
  ['axis', 'Full'],
];

export const static_rotate_axis = modifyArray([90, 60, 45, 30, 15, 0, -15, -30, -45, -60, -90]);

export const static_line_interpolation = modifyArray(['basic', 'smooth', 'step-line']);

export const static_page_length2 = modifyArray([1, 5, 10, 25, 50, 75, 100]);
export const static_link_length = modifyArray([10, 50, 100, 200, 250, 500]);
export const static_charge = modifyArray([-50, -75, -100, -150, -200, -250, -500, -1000]);
export const static_intensity_range = [
  ['auto', 'Auto'],
  ['manual', 'Manual'],
];
export const static_map_type = modifyArray(['Standard']);

export const static_rotation = [
  ['random', 'random'],
  ['flat', 'flat'],
  ['square', 'square'],
  ['circle', 'circle'],
  ['cardioid', 'cardioid'],
  ['diamond', 'diamond'],
  ['triangle-forward', 'triangle-forward'],
  ['triangle', 'triangle'],
];

export const static_spiral = [
  ['archimedean', 'archimedean'],
  ['rectangular', 'rectangular'],
];

export const static_horizontal_bar_sorter = [
  ['y_axis', 'Y Axis'],
  ['value', 'Value'],
];
export const static_list_sort_bins = [
  ['asc', 'Ascending'],
  ['desc', 'Descending'],
];
export const static_cols_notification = modifyArray(['==', '!=', '>', '<', '>=', '<=']);
export const static_cols = modifyArray(['in', 'not in', '==', '!=', '>', '<', '>=', '<=']);
export const static_pandas_aggfunc = modifyArray(['sum', 'mean', 'min', 'max']);
export const static_granularity = modifyArray([
  'all',
  '5 seconds',
  '30 seconds',
  '1 minute',
  '5 minutes',
  '1 hour',
  '6 hour',
  '1 day',
  '7 days',
  'one day',
  'week',
  'week_starting_sunday',
  'week_ending_saturday',
  'month',
]);
export const static_spectrums = {
  blue_white_yellow: ['#00d1c1', 'white', '#ffb400'],
  fire: ['white', 'yellow', 'red', 'black'],
  white_black: ['white', 'black'],
  black_white: ['black', 'white'],
  dark_blue: ['#EBF5F8', '#6BB1CC', '#357E9B', '#1B4150', '#092935'],
  pink_grey: ['#E70B81', '#FAFAFA', '#666666'],
  ['green/yellow/red']: ['green', 'yellow', 'red'],
};
export const static_shape = [
  ['circle', 'Circle'],
  ['cardioid', 'Cardioid'],
  ['diamond', 'Diamond'],
  ['triangle-forward', 'Triangle-forward'],
  ['triangle', 'Triangle'],
  ['pentagon', 'Pentagon'],
  ['star', 'Star'],
];
export const static_scale = [
  ['linear', 'Linear'],
  ['logN', 'Log N'],
  ['akarN', 'Akar N'],
  ['N', 'N'],
];

export const static_select_country_overlay = ['Indonesia', 'Usa'].map((s) => [s.toString().toLowerCase(), s]);
export const static_select_country = [
  'Indonesia',
  'Indonesia_kabupaten',
  'Belgium',
  'Brazil',
  'China',
  'Egypt',
  'France',
  'Germany',
  'Italy',
  'Morocco',
  'Netherlands',
  'Russia',
  'Singapore',
  'Spain',
  'Uk',
  'Ukraine',
  'Usa',
].map((s) => [s.toString().toLowerCase(), s]);
export const static_select_province = [
  'Aceh',
  'Bali',
  'Banten',
  'Bengkulu',
  'Daerah Istimewa Yogyakarta',
  'DKI Jakarta',
  'Gorontalo',
  'Jambi',
  'Jawa Barat',
  'Jawa Tengah',
  'Jawa Timur',
  'Kalimantan Barat',
  'Kalimantan Selatan',
  'Kalimantan Tengah',
  'Kalimantan Timur',
  'Kalimantan Utara',
  'Kepulauan Bangka Belitung',
  'Kepulauan Riau',
  'Lampung',
  'Maluku Utara',
  'Maluku',
  'Nusa Tenggara Barat',
  'Nusa Tenggara Timur',
  'Papua Barat',
  'Papua',
  'Riau',
  'Sulawesi Barat',
  'Sulawesi Selatan',
  'Sulawesi Tengah',
  'Sulawesi Tenggara',
  'Sulawesi Utara',
  'Sumatera Barat',
  'Sumatera Selatan',
  'Sumatera Utara',
].map((s) => [s.replace(/ /g, '-').replace(/\./g, '-').toLowerCase(), s]);
export const static_legend_orient = [
  ['horizontal', 'Horizontal'],
  ['vertical', 'Vertical'],
];
export const static_legend_type = [
  ['plain', 'Plain'],
  ['scroll', 'Scroll'],
];
export const static_dist_bar_sorter = [
  ['x_axis', 'X Axis'],
  ['value', 'Value'],
];

export const static_page_length = modifyArray([0, 5, 10, 25, 50, 100, 200, 500, 1000]);

export const static_y_axis_format = [
  ['.3s', 'Default'],
  [',', '12,345'],
  ['.1f', '1200.0'],
  ['.3f', '12345.432'],
  [',.2f', '1,500.00'],
  ['s', '1.5k'],
  ['.1s', '2k'],
  ['.2s', '1.5k'],
  [',.2%', '150,000.00%'],
  ['+,', '+12,345.4321'],
  ['$,.2f', '$12,345.43'],
  [',.2r', '12,345,678'],
  ['.1m', 'Milliar/Billion']
];

export const static_mode = [
  ['value', 'Value'],
  ['percent', 'Percentage'],
];
export const static_gauge_label_type = [
  ['value', 'Value'],
  ['percent', 'Percentage'],
  // ["category", "Category"],
  // ["status_percent", "Percentage and Value"],
];
export const static_pie_label_type = [
  ['key', 'Category Name'],
  ['value', 'Value'],
  ['percent', 'Percentage'],
  ['percent_around', 'Percentage Around'],
  ['key_value', 'Category and Value'],
  ['key_percent', 'Category and Percentage'],
  ['key_percent_around', 'Category and Percentage Around'],
];

export const staticfilterDateTypeListComparison = [
  ['static_date', 'Is Static Date'],
  ['static_month', 'Is Static Month'],
  ['static_year', 'Is Static Year'],
  ['date', 'Date'],
  ['month', 'Month'],
  ['year', 'Year'],
];

export const staticcolumnFormatList = [
  ['date', 'Date'],
  ['number', 'Number'],
];
export const staticfontFamilyList = [
  ['Roboto', 'Roboto (Default)'],
  ['Impact', 'Impact'],
  ['Helvetica', 'Helvetica'],
  ['Open Sans', 'Open Sans'],
  ['Verdana', 'Verdana'],
  ['sans-serif', 'Sans Serif'],
  ['Montserrat', 'Montserrat'],
  ['Lato', 'Lato'],
  ['Oswald', 'Oswald'],
  ['Poppins', 'Poppins'],
  ['Raleway', 'Raleway'],
];
export const staticinitialFilterDateList = [
  ['current_date', 'Current Date'],
  ['latest_date', 'Latest Date'],
  ['custom_date', 'Custom Date'],
];
export const statictable_selected_column = [];
export const statictable_selected_column_width = [];

export const staticcolumn_width_arr = [
  { style: '0 0 100% !important;', width: '100%' },
  { style: '0 0 75% !important;', width: '75%' },
  { style: '0 0 60% !important;', width: '60%' },
  { style: '0 0 55% !important;', width: '55%' },
  { style: '0 0 50% !important;', width: '50%' },
  { style: '0 0 45% !important;', width: '45%' },
  { style: '0 0 40% !important;', width: '40%' },
  { style: '0 0 35% !important;', width: '35%' },
  { style: '0 0 30% !important;', width: '30%' },
  { style: '0 0 25% !important;', width: '25%' },
  { style: '0 0 20% !important;', width: '20%' },
  { style: '0 0 15% !important;', width: '15%' },
  { style: '0 0 10% !important;', width: '10%' },
  { style: '0 0 5% !important;', width: '5%' },
  { style: '0 0 2% !important;', width: '2%' },
];

export const static_operators_arr = [
  { val: 'in', type: 'array', useSelect: true, multi: true },
  { val: 'not in', type: 'array', useSelect: true, multi: true },
  {
    val: '==',
    type: 'string',
    useSelect: true,
    multi: false,
    havingOnly: true,
  },
  {
    val: '!=',
    type: 'string',
    useSelect: true,
    multi: false,
    havingOnly: true,
  },
  { val: '>=', type: 'string', havingOnly: true },
  { val: '<=', type: 'string', havingOnly: true },
  { val: '>', type: 'string', havingOnly: true },
  { val: '<', type: 'string', havingOnly: true },
  { val: 'regex', type: 'string', datasourceTypes: ['druid'] },
];

export const static_time_grain_sqla = [
  ['hour', 'MODULE.DATA_VISUAL.CHART.MESSAGE.HOUR'],
  ['day', 'MODULE.DATA_VISUAL.CHART.MESSAGE.DAY'],
  ['month', 'MODULE.DATA_VISUAL.CHART.MESSAGE.MONTH'],
  ['year', 'MODULE.DATA_VISUAL.CHART.MESSAGE.YEAR'],
];

export const static_list_time_grain_sqla = [
  { value: 'hour', label: 'MODULE.DATA_VISUAL.CHART.MESSAGE.HOUR' },
  { value: 'day', label: 'MODULE.DATA_VISUAL.CHART.MESSAGE.DAY' },
  { value: 'month', label: 'MODULE.DATA_VISUAL.CHART.MESSAGE.MONTH' },
  { value: 'year', label: 'MODULE.DATA_VISUAL.CHART.MESSAGE.YEAR' },
];

export const staticfilterDateList = [
  ['date_picker', 'MODULE.DATA_VISUAL.CHART.MESSAGE.DATE_PICKER'],
  ['date_range_picker', 'MODULE.DATA_VISUAL.CHART.MESSAGE.DATE_RANGE_PICKER'],
];
export const staticfilterDateTypeList = [
  ['date', 'MODULE.DATA_VISUAL.CHART.MESSAGE.DATE'],
  ['month', 'MODULE.DATA_VISUAL.CHART.MESSAGE.MONTH'],
  ['year', 'MODULE.DATA_VISUAL.CHART.MESSAGE.YEAR'],
];

// export const static_open_dialog = {
//   setting: false,
//   notification: false,
//   help: false,
//   language: false,
//   user: false,
// };

export const static_bar_type_query = [
  {
    value: 'dist_bar',
    label: 'MODULE.DATA_VISUAL.CHART.RIGHT_BAR.QUERY.VBC',
  },
  {
    value: 'horizontal_bar',
    label: 'MODULE.DATA_VISUAL.CHART.RIGHT_BAR.QUERY.HBC',
  },
];

export const static_sparkline_type_query = [
  {
    value: 'bar',
    label: 'Bar',
  },
  {
    value: 'line',
    label: 'Line',
  },
];

export const static_bar_with_line_query = [
  ['line_metric', 'Line Metric'],
  ['line_constanta', 'Line Constanta'],
];

export const static_table_type_query = [
  {
    value: 'table',
    label: 'MODULE.DATA_VISUAL.CHART.RIGHT_BAR.QUERY.T',
  },
  {
    value: 'pivot_table',
    label: 'MODULE.DATA_VISUAL.CHART.RIGHT_BAR.QUERY.PT',
  },
];

export const static_active_tabs_table_chart = [
  {
    value: 'group',
    label: 'Group',
  },
  {
    value: 'not_group',
    label: 'Not Group',
  },
];

export const static_line_type_query = [
  {
    value: 'line',
    label: 'MODULE.DATA_VISUAL.CHART.RIGHT_BAR.QUERY.LINE_CHART',
  },
  {
    value: 'dual_line',
    label: 'MODULE.DATA_VISUAL.CHART.RIGHT_BAR.QUERY.DLA',
  },
];

export const static_map_type_query = [
  {
    value: 'country_map',
    label: 'MODULE.DATA_VISUAL.CHART.RIGHT_BAR.QUERY.CM',
  },
];

export const static_list_formula = {
  description: null,
  expression: 'Sum(column_name)',
  metric_name: 'sum__column_name',
  verbose_name: 'column_name (Sum)',
  warning_text: null,
  is_formula: true,
};

export const static_format_number_chart_options = [
  {
    value: true,
    label: 'Indonesia ',
  },
  {
    value: false,
    label: 'US-International',
  },
];

export const static_display_view_table_chart_options = (form_data) => [
  {
    value: 'table', //form_data.table_grid_view && form_data.gridview_list_view
    label: 'Table ',
    name: '',
  },
  {
    value: 'grid',
    label: 'Grid View',
    name: 'table_grid_view',
  },
  {
    value: 'list',
    label: 'List View',
    name: 'gridview_list_view',
  },
];

export const static_label_position_pie_chart_options = (form_data) => [
  {
    value: 'inside', //!form_data.labels_outside && !form_data.hide_label
    label: 'Inside Chart',
    name: '',
  },
  {
    value: 'outside',
    label: 'Outside Chart',
    name: 'labels_outside',
  },
  {
    value: 'hide',
    label: 'Hide Label',
    name: 'hide_label',
  },
];

export const static_list_area_map = [
  { label: 'Indonesia', value: '', group: 'Indonesia' },
  { label: 'Aceh', value: 'aceh', group: 'Indonesia' },
  { label: 'Bali', value: 'bali', group: 'Indonesia' },
  { label: 'Banten', value: 'banten', group: 'Indonesia' },
  { label: 'Bengkulu', value: 'bengkulu', group: 'Indonesia' },
  { label: 'Daerah Istimewa Yogyakarta', value: 'daerah-istimewa-yogyakarta', group: 'Indonesia' },
  { label: 'DKI Jakarta', value: 'dki-jakarta', group: 'Indonesia' },
  { label: 'Gorontalo', value: 'gorontalo', group: 'Indonesia' },
  { label: 'Jambi', value: 'jambi', group: 'Indonesia' },
  { label: 'Jawa Barat', value: 'jawa-barat', group: 'Indonesia' },
  { label: 'Jawa Tengah', value: 'jawa-tengah', group: 'Indonesia' },
  { label: 'Jawa Timur', value: 'jawa-timur', group: 'Indonesia' },
  { label: 'Kalimantan Barat', value: 'kalimantan-barat', group: 'Indonesia' },
  { label: 'Kalimantan Selatan', value: 'kalimantan-selatan', group: 'Indonesia' },
  { label: 'Kalimantan Tengah', value: 'kalimantan-tengah', group: 'Indonesia' },
  { label: 'Kalimantan Timur', value: 'kalimantan-timur', group: 'Indonesia' },
  { label: 'Kalimantan Utara', value: 'kalimantan-utara', group: 'Indonesia' },
  { label: 'Kepulauan Bangka Belitung', value: 'kepulauan-bangka-belitung', group: 'Indonesia' },
  { label: 'Kepulauan Riau', value: 'kepulauan-riau', group: 'Indonesia' },
  { label: 'Lampung', value: 'lampung', group: 'Indonesia' },
  { label: 'Maluku Utara', value: 'maluku-utara', group: 'Indonesia' },
  { label: 'Maluku', value: 'maluku', group: 'Indonesia' },
  { label: 'Nusa Tenggara Barat', value: 'nusa-tenggara-barat', group: 'Indonesia' },
  { label: 'Nusa Tenggara Timur', value: 'nusa-tenggara-timur', group: 'Indonesia' },
  { label: 'Papua Barat', value: 'papua-barat', group: 'Indonesia' },
  { label: 'Papua', value: 'papua', group: 'Indonesia' },
  { label: 'Riau', value: 'riau', group: 'Indonesia' },
  { label: 'Sulawesi Barat', value: 'sulawesi-barat', group: 'Indonesia' },
  { label: 'Sulawesi Selatan', value: 'sulawesi-selatan', group: 'Indonesia' },
  { label: 'Sulawesi Tengah', value: 'sulawesi-tengah', group: 'Indonesia' },
  { label: 'Sulawesi Tenggara', value: 'sulawesi-tenggara', group: 'Indonesia' },
  { label: 'Sulawesi Utara', value: 'sulawesi-utara', group: 'Indonesia' },
  { label: 'Sumatera Barat', value: 'sumatera-barat', group: 'Indonesia' },
  { label: 'Sumatera Selatan', value: 'sumatera-selatan', group: 'Indonesia' },
  { label: 'Sumatera Utara', value: 'sumatera-utara', group: 'Indonesia' },
  { label: 'Peta Dishub', value: 'sumatera-utara', group: '' },
  { label: 'Polda Aceh', value: 'polda-aceh', group: 'Polda' },
  { label: 'Polda Bali', value: 'polda-bali', group: 'Polda' },
];

export const static_legend_heatmap = [
  ['piecewise', 'Plain'],
  ['continuous', 'Continuous'],
];

export const static_floating_card_dashboard = [
  // {
  //   type: 'Apply',
  //   icon: 'zmdi zmdi-check ml-1',
  //   typeChart: ['filter_box'],
  //   typePage: ['dashboardview', 'app_preview'],
  //   isEditor: false,
  // },
  {
    type: 'column_table',
    icon: 'zmdi zmdi-power-input',
    typeChart: ['table', 'pivot_table'],
    typePage: ['dashboardview', 'dashboard', 'app_preview'],
  },
  {
    type: 'select',
    icon: 'zmdi zmdi-select-all',
    typeChart: [
      'table',
      'pivot_table',
      'gauge',
      'big_number_total',
      'country_map',
      'markup',
      'treemap',
      'predictive',
      'scatter',
      'word_cloud',
      'table_comparison',
      'histogram',
      'dist_bar',
      'horizontal_bar',
      'line',
      'dual_line',
      'pie',
      'directed_force',
      'bubble',
      'heatmap',
      'sunburst',
      'sparkline',
      'sparkline_table',
    ],
    typePage: ['dashboard'],
  },
  {
    type: 'fullscreen',
    icon: 'zmdi zmdi-fullscreen',
    typeChart: [
      'table',
      'pivot_table',
      'gauge',
      'big_number_total',
      'country_map',
      'markup',
      'treemap',
      'predictive',
      'scatter',
      'word_cloud',
      'table_comparison',
      'histogram',
      'dist_bar',
      'horizontal_bar',
      'line',
      'dual_line',
      'pie',
      'directed_force',
      'bubble',
      'heatmap',
      'sunburst',
      'sparkline',
      'sparkline_table',
      'map_density',
      'map_pin_point',
      'map_polygon'
    ],
    typePage: ['dashboardview', 'app_preview'],
  },
  {
    type: 'refresh',
    icon: 'zmdi zmdi-refresh-alt',
    typeChart: [
      'table',
      'pivot_table',
      'gauge',
      'big_number_total',
      'country_map',
      'markup',
      'treemap',
      'predictive',
      'scatter',
      'word_cloud',
      'table_comparison',
      'dual_line',
      'histogram',
      'dist_bar',
      'horizontal_bar',
      'line',
      'dual_line',
      'pie',
      'directed_force',
      'bubble',
      'heatmap',
      'sunburst',
      'sparkline',
      'sparkline_table',
      'error',
      'map_density',
      'map_pin_point',
      'map_polygon',
    ],
    typePage: ['dashboardview', 'dashboard', 'app_preview'],
  },
  {
    type: 'edit',
    icon: 'zmdi zmdi-edit',
    typeChart: [
      'table',
      'pivot_table',
      'gauge',
      'big_number_total',
      'country_map',
      'markup',
      'treemap',
      'predictive',
      'scatter',
      'word_cloud',
      'table_comparison',
      'histogram',
      'dist_bar',
      'horizontal_bar',
      'line',
      'dual_line',
      'pie',
      'directed_force',
      'bubble',
      'heatmap',
      'sunburst',
      'filter_box',
      'sparkline',
      'sparkline_table',
      'error',
      'map_density',
      'map_pin_point',
      'numerical_filter',
      'map_polygon',
    ],
    typePage: ['dashboard'],
  },
  {
    type: 'download',
    icon: 'zmdi zmdi-download',
    typeChart: [
      'table',
      'pivot_table',
      'gauge',
      'big_number_total',
      'country_map',
      'treemap',
      'predictive',
      'scatter',
      'word_cloud',
      'table_comparison',
      'dual_line',
      'histogram',
      'dist_bar',
      'horizontal_bar',
      'line',
      'dual_line',
      'pie',
      'directed_force',
      'bubble',
      'heatmap',
      'sunburst',
      'sparkline',
      'sparkline_table',
    ],
    typePage: ['dashboardview', 'app_preview'],
  },
  {
    type: 'delete',
    icon: 'zmdi zmdi-delete',
    typeChart: [
      'table',
      'pivot_table',
      'gauge',
      'big_number_total',
      'country_map',
      'markup',
      'treemap',
      'predictive',
      'scatter',
      'word_cloud',
      'table_comparison',
      'dual_line',
      'histogram',
      'dist_bar',
      'horizontal_bar',
      'line',
      'dual_line',
      'pie',
      'directed_force',
      'bubble',
      'heatmap',
      'sunburst',
      'filter_box',
      'sparkline',
      'sparkline_table',
      'error',
      'map_density',
      'map_pin_point',
      'numerical_filter',
      'map_polygon',
    ],
    typePage: ['dashboard'],
  },
];

export const static_dashboard_field_auto_refresh = [
  {
    value: true,
    label: 'MODULE.DATA_VISUAL.DASHBOARD.RIGHT_BAR.E',
  },
  {
    value: false,
    label: 'MODULE.DATA_VISUAL.DASHBOARD.RIGHT_BAR.D',
  },
];

export const static_dashboard_field_refresh_interval = [
  {
    value: 300000,
    label: '5 Minutes',
  },
  {
    value: 600000,
    label: '10 Minutes',
  },
  {
    value: 1200000,
    label: '20 Minutes',
  },
  {
    value: 1800000,
    label: '30 Minutes',
  },
  {
    value: 2400000,
    label: '40 Minutes',
  },
  {
    value: 3000000,
    label: '50 Minutes',
  },
  {
    value: 3600000,
    label: '1 Hour',
  },
  {
    value: 7200000,
    label: '2 Hour',
  },
  {
    value: 14400000,
    label: '4 Hour',
  },
  {
    value: 28800000,
    label: '8 Hour',
  },
  {
    value: 43200000,
    label: '12 Hour',
  },
  {
    value: 86400000,
    label: '24 Hour',
  },
];

export const static_chart_field_refresh_interval = [
  {
    value: 1000,
    label: '1 Second',
  },
  {
    value: 5000,
    label: '5 Seconds',
  },
  {
    value: 10000,
    label: '10 Seconds',
  },
  {
    value: 20000,
    label: '20 Seconds',
  },
  {
    value: 30000,
    label: '30 Seconds',
  },
  ...static_dashboard_field_refresh_interval
];

export const static_column_type = [
  ['number', 'Number'],
  ['line', 'Line'],
  ['bar', 'Bar'],
];

export const logoPaquesBase64 =
  'data:image/png;base64,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';

export const static_list_marker = [
  {
    value: 'circle',
    tooltip: 'Circle',
    icon: 'zmdi zmdi-circle',
  },
  {
    value: 'square',
    tooltip: 'Square',
    icon: 'zmdi zmdi-square-o',
  },
  {
    value: 'triangle',
    tooltip: 'Triangle',
    icon: 'zmdi zmdi-triangle-up',
  },
  {
    value: 'car',
    tooltip: 'Car',
    icon: 'zmdi zmdi-car',
  },
  {
    value: 'plus',
    tooltip: 'Plus',
    icon: 'zmdi zmdi-plus',
  },
  {
    value: 'ex',
    tooltip: 'X',
    icon: 'zmdi zmdi-close-circle-o',
  },
  {
    value: 'bus',
    tooltip: 'Bus',
    icon: 'zmdi zmdi-bus',
  },
  {
    value: 'car_crash',
    tooltip: 'Car Crash',
    iconUrl:  'assets/images/map/icon/car-crash.svg',
  },
  {
    value: 'user_injured',
    tooltip: 'User Injured',
    iconUrl:  'assets/images/map/icon/user_injured.svg',
  },
];

export const static_list_filter_type = [
  { value: 'slider', label: 'Slider' },
];
